import { createUseStyles } from 'react-jss';
const useCounterStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        width: 'fit-content'
    },
    base: {
        display: 'flex',
        alignItems: 'center'
    },
    text: {
        fontSize: '12px',
        lineHeight: '16px',
        color: theme.colors.grey[1]
    },
    value: {
        marginLeft: '8px',
        marginRight: '8px',
        color: ({ disabled }) => disabled ? theme.colors.grey[2] : theme.colors.common.black,
        fontSize: ({ size }) => (size === 'xl' ? '20px' : '16px'),
        lineHeight: ({ size }) => (size === 'xl' ? '28px' : '24px')
    },
    icons: {
        '&:hover': {
            cursor: 'pointer'
        }
    },
    disabled: {
        pointerEvents: 'none'
    }
}));
export default useCounterStyles;
